/**
 * "This device only" — a workspace tracked in a LOCAL git repository with no
 * remote (Track on this device, T1, 04.10.2026). Changes, History, Restore,
 * Discard and the request History button work as for a synced workspace; the
 * versions stay in the mirror folder on this device until the user adds a
 * remote (GitHub, GitLab or another server) and pushes the existing history.
 *
 * The link is { provider: 'local', branch: 'main', since } — no owner, repo,
 * url, account or Vault item. Nothing here talks to a network: there is no
 * token, no repository to create, no page to open.
 */
const local = {
  id: 'local',
  label: 'This device',
  icon: 'device',
  authKinds: [],
  baseUrl: '',
  abilities: { createRepo: false, listRepos: false, openInBrowser: false, deviceFlow: false, tagWorkspace: false },
  /** Nothing to sign in to — a local link is never "not linked". */
  localOnly: true,
  httpsUsername: undefined,
  notLinkedCode: 'LOCAL_ONLY',

  async getToken() {
    return '';
  },

  /**
   * Always "connected". The commit author is the Apiboo display name when
   * one is known (or Rust's default "Apiboo") — these commits may be pushed
   * to a public repository later, so the address is always the no-reply one.
   */
  async getAccount() {
    let login = '';
    try {
      const { useAuthStore } = await import('../../../store/authStore');
      const user = useAuthStore.getState()?.user;
      login = String(user?.name || user?.username || '').trim();
    } catch {
      login = '';
    }
    return { connected: true, login, avatarUrl: '', label: 'This device' };
  },

  authorEmail() {
    return 'noreply@apiboo.com';
  },

  async repoUrl() {
    return '';
  },

  webUrl() {
    return '';
  },

  parseRepo() {
    return null;
  },
};

export default local;
